import { HTTP, authHeader } from './http-service';

class ComplaintSearchService {
  search(payload) {
    return HTTP.post(`/ComplaintSearch`, payload, {
      headers: authHeader(),
    }).then((response) => {
      return response.data;
    });
  }

  advancedSearch(payload) {
    return HTTP.post(`/ComplaintSearch/advance`, payload, {
      headers: authHeader(),
    }).then((response) => {
      return response.data;
    });
  }

  getComplaintStatusesCount(owner) {
    return HTTP.post(
      `/ComplaintSearch/complaintStatusesCount`,
      { owner },
      {
        headers: authHeader(),
      },
    ).then((response) => response.data.model);
  }
}

export default new ComplaintSearchService();
